import { createFileRoute } from "@tanstack/react-router";
import { AccountDetail } from "../-accounts/AccountDetail";

export const Route = createFileRoute("/admin/accounts/$userId")({
  staticData: { title: "Account" },
  component: AccountDetail,
});
